import Prebook from '@/store/prebook.js';
import { addPaymentMethod, getProductsCartInfo } from '@/utils/analytics.js';
import { formatPrebookDate, getCurrentDayTitle, getTimezone } from '@/utils/dates/dates.js';
import React, { useState, useEffect, useContext, useMemo, useRef } from 'react';
import { useRouter } from 'next/router';
import cn from 'classnames';
import { distinctUntilChanged } from 'rxjs/operators';
import {
  Heading,
  HeadingEnum,
  BoldEnum,
  CheckoutPage,
  WaveBreadCrumb,
  TextColorEnum,
  OffersSnackbar,
  ArrowBack,
  SnackBar,
  SideSheet,
  GuestContactForm,
  Switch,
  Text,
  TextEnum,
} from '@desquared/wave-components-library';
import TimeslotsAside from '@/components/TimeslotsAside/TimeslotsAside';
import { DeliveryServicesContext } from '@/contexts/DeliveryServicesContext.jsx';
import { fullCartStore, checkoutStore, isEditStarted } from '@/store/cart';
import {
  PaymentOptionStore,
  SideSheetStore,
  TimesSlotsSideSheetStore,
  PrebookSideSheetStore,
  //InitPickupMethodStore,
  PointsSideSheetStore,
  CountryCodeSideSheetStore,
  CouponAdditionSideSheetOpen,
} from '@/store/sideSheet';
import User from '@/store/user';
import { Shop } from '@/store/shop';
import { PostalCode, SelectedShopId } from '@/store/isAddressRegistered';
import { mockCheckoutData } from '@/mocks/fullPageCartMocks';
import {
  fetchTimeslotsTakeAway,
  fetchTimeslotsDelivery,
  changeSelectedIndexes,
  EXACT_DATE_TIMESLOT_TOKEN,
  PREDICTION_TIMESLOT_TOKEN,
  createPredictiveTimeslotTextWithDate,
  createTimeslotsProducts,
} from '@/utils/logic/timeslots';
import { onConfirmRedemption, onSelectPoints, onClearRedemption } from '@/utils/logic/points';
import { submitOrderCart } from '@/api/wave/orders';
import { checkCoupon } from '@/utils/coupons';
import useChargeDiscountBreakdown from '@/hooks/usePriceBreakdown';
import { GeneralSelectedTimeslotStore, FirstSelectedTimeslotStore } from '@/store/selectedTimeslot';
import LoaderStore from '@/store/loader';
import GuestUserStore from '@/store/guestUser';
import {
  ACCEPTED_STATE,
  formatTimeslots,
  getDelivery,
  getPaymentCard,
  getShopId,
  submitProducts,
  addStickers,
  constructAddressLine,
} from '@/utils/products/products';
import {
  getBagsConfigurations,
  getOrFetchConfiguration,
  getPaymentMethods,
  updateConfiguration,
} from '@/utils/getConfiguration';
import styles from './Checkout.module.css';
import PointsAside from '../PointsAside/PointsAside';
import usePoints from '@/hooks/usePoints';
import { VOUCHER_TOKEN, useCheckoutPreferences } from '@/hooks/useCheckoutPreferences';
import { useTranslations } from 'next-intl';
import { useCheckOrderCheckout } from '@/hooks/useCheckOrderCheckout';
import useGenericTimeslots from '@/hooks/useGenericTimeslots';
import { transfromTimeslots } from '@/utils/transformers/transformTimeslots';
import { formatUTCTimeslotsToLocal } from '@/utils/dates/dates.js';
import { CurrencyContext } from '@/contexts/CurrencyProvider';
import { useDateFormatting } from '@/contexts/DateFormattingProvider';
import { formatAddress } from '@/utils/addressUtilities';
import CountryCodeAside from '../Aside/CountryCodeAside';
import { useConfiguration } from '@/contexts/ConfigContext';
import { CountryCodeStore } from '@/store/countryCode';
import isEqual from 'lodash/isEqual';
import sortBy from 'lodash/sortBy';
import { ModalContext } from '@/contexts/ModalProvider';
import Link from 'next/link';
import { isFromOrder } from '@/store/questionnaire';
import Cookies from 'universal-cookie';
import { clearCart } from '@/utils/cart';
import { deleteCart } from '@/api/syncCart';
import { createInvoice, deleteInvoice, getInvoices, updateInvoice } from '@/api/invoices.js';
import jsonStorage from '@/utils/json-storage.js';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { UserIsOfLegalAgeStore } from '@/store/userIsOfLegalAge.js';
import CouponsSidesheet from '@/components/CouponsSideSheet/CouponsSideSheet';
import { getCoupons } from '@/api/wave/users';

export default function Checkout({ user, defaultWarningImage }) {
  const cookies = new Cookies();
  const authorization = cookies.get('token');
  const router = useRouter();
  const queryClient = useQueryClient();
  const t = useTranslations();
  const breadCrumbItems = [
    { title: t('checkout.back'), link: router.locale === router.defaultLocale ? '/cart' : `/${router.locale}/cart` },
  ];
  const [priceCart, setCartPrice] = useState();
  const [order, setOrder] = useState(fullCartStore.getValue()?.data?.order);
  const [bags, setBags] = useState(false);
  const [discountstate, setDiscountState] = useState(false);
  const [saveCard, setSaveCard] = useState(false);
  const [wantsBottles, setWantsBottles] = useState(false);
  const [wantsVouchers, setWantsVouchers] = useState(false);
  const [details, setDetails] = useState(false);
  const [hasCoupon, setHasCoupon] = useState(false);
  const [coupon, setCoupon] = useState('');
  const [couponSideSheet, setCouponSideSheet] = useState('');
  const [couponDiscountAmmount, setCouponDiscountAmmount] = useState('');
  const [couponIsEligible, setCouponIsEligible] = useState(true);

  const [pointsToRedeem, setPointsToRedeem] = useState();
  const [amountToRedeem, setAmountToRedeem] = useState();
  const [breakdownCategories, setBreakdownCategories] = useState([]);
  const [comments, setComments] = useState('');
  const [paymentIndex, setPaymentIndex] = useState(0);
  const [genericIndexes, setGenericIndexes] = useState({});
  const [sideSheet, setSideSheet] = useState(false);
  const [runCheck, setRunCheck] = useState(true);
  const [snackBarText, setSnackBarText] = useState(t('common.timeslots.checkout_select_timeslot_error'));
  const [timeslotDropdownOptions, setTimeslotDropdownOptions] = useState([
    {
      name: t('common.timeslots.unsupported_region'),
      unavailable: true,
    },
  ]);
  const [genericTransformedTimeslots, setGenericTransformedTimeslots] = useState({});
  const [message, setMessage] = useState('');
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  // const [addressPickerStatus, setAddressPickerStatus] = useState();
  const [shop, setShop] = useState();
  const [config, setConfig] = useState();
  const [previousIndexes, setPreviousIndexes] = useState({});
  const [genericTimeslots, setGenericTimeslots] = useState({});
  const [postalCode, setPostalCode] = useState('');
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [selectedShopId, setSelectedShopId] = useState(null);
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [couponError, setCouponError] = useState('');
  const [couponSuccess, setCouponSuccess] = useState('');
  const [couponDiscount, setCouponDiscount] = useState({ isValid: false, message: '', amount: 0 });
  const [prebook, setPrebook] = useState();
  const [hasPredictiveTimeslot, setHasPredictiveTimeSlot] = useState(false);
  const [predictiveTimeslotText, setPredictiveTimeslotText] = useState('');
  const { selectedService, addressPickerStatus, selectedUserAddressIndex, getCollectionTypes, selectedShop } =
    useContext(DeliveryServicesContext);
  const { formatter } = useContext(CurrencyContext);
  const { timeFormat } = useDateFormatting();
  const { config: configVar, requiresAddressLine } = useConfiguration();

  const [guestUser, setGuestUser] = useState();
  const [collectionTypes, setCollectionTypes] = useState([]);
  const [countryCodeAsideOpen, setCountryCodeAsideOpen] = useState(false);
  const [countryCode, setCountryCode] = useState(CountryCodeStore.getValue()[0]);
  const [guestContactAsideOpen, setGuestContactAsideOpen] = useState(false);
  const [guestContactValid, setGuestContactValid] = useState(false);
  const [guestContactValues, setGeustContactValues] = useState();
  const { openActionModal, close } = useContext(ModalContext);
  const [invoices, setInvoices] = useState([]);
  const [selectedCompanyIndex, setSelectedCompanyIndex] = useState(-1);
  const [invoiceToSend, setInvoiceToSend] = useState();
  const [checkBoxChecked, setCheckBoxChecked] = useState(false);
  const [invoiceAction, setInvoiceAction] = useState('create');
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [updateInvoiceIndex, setUpdateInvoiceIndex] = useState(0);
  const [temporaryInvoice, setTemporaryInvoice] = useState();
  const [notSavedInvoiceFlag, setNotSavedInvoiceFlag] = useState(false);
  const isGuest = !authorization;
  const previousAction = useRef('continue');

  const formFieldErrorMessages = {
    required: t('common.checkout.required_field'),
    invalidEmail: t('guest_login.errors.invalid_email'),
    invalidPhone: t('guest_login.errors.invalid_mobile'),
  };

  const invoiceSelectorTexts = {
    saveInvoiceText: t('checkout.invoice.save_invoice'),
    invoiceDetailsText: t('checkout.invoice.invoice_details'),
    savedProfilesText: t('checkout.invoice.saved_invoices'),
    newInvoiceText: t('checkout.invoice.new_invoice'),
    cancelUpdateButtonText: t('checkout.invoice.cancel_invoice'),
    continueButtonText: t('checkout.invoice.continue_invoice'),
    updateButtonText: t('checkout.invoice.update_invoice'),
  };

  const { data: fetchedInvoices } = useQuery({
    queryKey: ['getInvoices'],
    queryFn: () => getInvoices(authorization),
    enabled: !isGuest,
  });

  useEffect(() => {
    if (fetchedInvoices?.data && !isGuest) {
      setInvoices(fetchedInvoices.data);
    }
  }, [fetchedInvoices, isGuest]);

  // this useeffect is to set the data to prefill the form if not saved
  useEffect(() => {
    const storage = window.localStorage;
    const tempInv = jsonStorage.get('temporaryInvoice', { storage });
    const notSavedInvoiceFlag = jsonStorage.get('notSavedInvoiceFlag', { storage });

    if (tempInv && notSavedInvoiceFlag) {
      setTemporaryInvoice(tempInv);
    }

    if (notSavedInvoiceFlag) {
      setNotSavedInvoiceFlag(notSavedInvoiceFlag);
    }
  }, []);

  //this useeffect is to set the selected company index based on the temporaryInvoice saved in localstorage
  // or to reset the form if there are no invoices
  useEffect(() => {
    if (!isGuest) {
      const storage = window.localStorage;
      const tempInv = jsonStorage.get('temporaryInvoice', { storage });

      const noInvoices = invoices.length === 0;
      const hasInvoices = invoices.length > 0;

      if (noInvoices) {
        setIsFormVisible(true);
        setInvoiceAction('create');
        setInvoiceToSend(undefined);
        setSelectedCompanyIndex(-1);
      } else {
        setIsFormVisible(false);
        setInvoiceAction('continue');
      }

      if (tempInv) {
        const invoiceIndex = invoices.findIndex(invoice => invoice._id === tempInv._id);

        if (previousAction.current !== 'update') {
          if (invoiceIndex !== -1) {
            setSelectedCompanyIndex(invoiceIndex);
          } else {
            setSelectedCompanyIndex(-1);
            setIsFormVisible(true);
            setInvoiceAction('create');
          }
        }
      } else {
        if (hasInvoices && previousAction.current !== 'update') {
          setSelectedCompanyIndex(0);
        }
      }

      previousAction.current = 'continue';
    }
  }, [invoices, isGuest]);

  const handleCreateInvoice = async invoiceFormValue => {
    const storage = window.localStorage;

    //we want to save invoice only if the checkbox is checked
    if (checkBoxChecked) {
      jsonStorage.remove('notSavedInvoiceFlag', { storage });
      setNotSavedInvoiceFlag(false);

      const res = await createInvoice(invoiceFormValue, authorization);
      jsonStorage.set('temporaryInvoice', res?.data, { storage });
      setTemporaryInvoice(res?.data);

      // Update the cached data
      setInvoices(prev => [...prev, res?.data]);
      queryClient.setQueryData(['getInvoices'], old => {
        if (!old) return { data: [res.data] };
        return {
          ...old,
          data: [...old.data, res.data],
        };
      });

      setIsFormVisible(false);
      setSnackBarOpen(true);
      setSnackBarText(t('checkout.invoice.create_snack'));
    } else {
      jsonStorage.set('notSavedInvoiceFlag', true, { storage });
      setNotSavedInvoiceFlag(true);

      jsonStorage.set('temporaryInvoice', invoiceFormValue, { storage });
      setTemporaryInvoice(invoiceFormValue);
    }

    setInvoiceToSend(invoiceFormValue);
    setCheckBoxChecked(false);
  };

  const handleDeleteInvoice = index => {
    openActionModal({
      closeOnOuterClick: true,
      hasCenteredText: true,
      title: t('checkout.invoice.delete_modal_title'),
      text:
        t('checkout.invoice.delete_modal_description') +
        ' ' +
        invoices[index].companyName +
        (router.locale === 'el' ? ';' : '?'),
      actions: [
        {
          btnLabel: t('checkout.invoice.delete_invoice_modal_button'),
          onClick: async () => {
            close();
            const invoiceToDelete = invoices[index];
            const storage = window.localStorage;

            if (invoiceToDelete) {
              await deleteInvoice(invoiceToDelete._id, authorization);

              queryClient.setQueryData(['getInvoices'], old => {
                if (!old) return old;
                return {
                  ...old,
                  data: old.data.filter(inv => inv._id !== invoiceToDelete._id),
                };
              });

              const filteredInvoices = invoices.filter(invoice => invoice._id !== invoiceToDelete._id);
              setInvoices(filteredInvoices);
            }

            if (index === selectedCompanyIndex) {
              jsonStorage.remove('temporaryInvoice', { storage });
            }

            setInvoiceAction('continue');
          },
        },
        {
          btnLabel: t('checkout.invoice.cancel_invoice'),
          onClick: () => {
            close();
          },
          btnVariant: 'text',
        },
      ],
      img: {
        url: '/assets/wave-grocery/BananaWorried.png',
        ariaLabel: t('common.header.service_modal.description'),
        size: 'medium',
      },
    });
  };

  const handleUpdateInvoice = async (index, invoiceFormValue) => {
    const invoiceToUpdate = invoices[index];
    const storage = window.localStorage;
    const tempInv = jsonStorage.get('temporaryInvoice', { storage });

    if (invoiceToUpdate) {
      await updateInvoice(invoiceFormValue, invoiceToUpdate._id, authorization);
      const updatedInvoices = invoices.map((item, i) => (i === index ? { ...item, ...invoiceFormValue } : item));

      queryClient.setQueryData(['getInvoices'], old => {
        if (!old) return old;
        return {
          ...old,
          data: old.data.map(inv => (inv._id === invoiceToUpdate._id ? { ...inv, ...invoiceFormValue } : inv)),
        };
      });

      setInvoices(updatedInvoices);
      setIsFormVisible(false);

      if (tempInv?.hasOwnProperty('_id') && invoiceToUpdate._id === tempInv._id) {
        jsonStorage.set('temporaryInvoice', { ...invoices[selectedCompanyIndex], ...invoiceFormValue }, { storage });
      }

      previousAction.current = 'update';
      setInvoiceToSend(invoiceFormValue);
      setInvoiceAction('continue');
      setSnackBarOpen(true);
      setSnackBarText(t('checkout.invoice.update_snack'));
    }
  };

  const handleClearFormWarning = (reset, closeSideSheet) => {
    openActionModal({
      closeOnOuterClick: true,
      hasCenteredText: true,
      title: t('checkout.invoice.not_saved_title'),
      text: t('checkout.invoice.not_saved_description'),
      actions: [
        {
          btnLabel: t('checkout.invoice.continue_invoice'),
          onClick: () => {
            const emptyForm = {
              companyName: '',
              profession: '',
              taxId: '',
              taxOffice: '',
              companyAddress: '',
              companyPhone: '',
            };

            close();
            const storage = window.localStorage;

            setTemporaryInvoice(undefined);
            setNotSavedInvoiceFlag(false);
            setInvoiceToSend(invoices[selectedCompanyIndex]);
            jsonStorage.remove('temporaryInvoice', { storage });
            jsonStorage.remove('notSavedInvoiceFlag', { storage });
            reset(emptyForm);
            closeSideSheet();
          },
        },
        {
          btnLabel: t('checkout.invoice.cancel_invoice'),
          onClick: () => {
            setSelectedCompanyIndex(-1);
            setIsFormVisible(true);
            setInvoiceAction('create');
            setInvoiceToSend(temporaryInvoice);
            reset(temporaryInvoice);
            close();
          },
          btnVariant: 'text',
        },
      ],
      img: {
        url: '/assets/wave-grocery/BananaWorried.png',
        ariaLabel: t('common.header.service_modal.description'),
        size: 'medium',
      },
    });
  };

  useEffect(() => {
    const subs = [
      GuestUserStore.subscribe(u => {
        setGuestUser(u);
        if (u?.contactInfo?.countryCode) CountryCodeStore.update([u?.contactInfo?.countryCode]);
      }),
      CountryCodeStore.subscribe(cc => setCountryCode(cc[0])),
      CountryCodeSideSheetStore.subscribe(setCountryCodeAsideOpen),
    ];

    return () => {
      for (const sub of subs) sub.unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (!selectedShop?.collectionTypes) return;

    if (!isEqual(sortBy(selectedShop.collectionTypes), sortBy(collectionTypes)) && collectionTypes.length !== 0) {
      openActionModal({
        closeOnOuterClick: true,
        hasCenteredText: true,
        title: t('common.guest_address.collection_types_modal.title'),
        text: t('common.guest_address.collection_types_modal.description'),
        actions: [
          {
            btnLabel: t('common.header.service_modal.continue'),
            onClick: () => {
              close();
              router.push('/cart');
            },
          },
          {
            btnLabel: t('common.header.service_modal.close'),
            onClick: () => {
              close();
            },
            btnVariant: 'text',
          },
        ],
        img: {
          url: defaultWarningImage,
          ariaLabel: t('common.guest_address.collection_types_modal.description'),
          size: 'medium',
        },
      });
    }

    setCollectionTypes(selectedShop.collectionTypes);
  }, [selectedShop]);

  const guestContactConfig = useMemo(() => {
    if (guestUser) {
      return {
        enabled: !!guestUser && !User.getValue(),
        title: t('checkout.guest.contact.title'),
        substitle: guestUser.contactInfo
          ? `${guestUser.contactInfo?.email}, ${guestUser.contactInfo?.countryCode} ${guestUser.contactInfo?.phone}`
          : t('checkout.guest.contact.subtitle'),
        subtitleHasError: !guestUser.contactInfo,
        onClick: () => {
          setGuestContactAsideOpen(true);
        },
      };
    }

    return undefined;
  }, [t, guestUser, setGuestContactAsideOpen]);

  const isPrebookingEnabled =
    false || (!!User.getValue() && !GuestUserStore.getValue()) ? selectedService?.timeslots?.prebook?.enabled : false;
  const invoiceValidationRules = configVar?.order?.invoice?.enabled
    ? {
        companyName: { required: t('common.checkout.required_field') },
        companyPhone: { required: t('common.checkout.required_field') },
        taxId: { required: t('common.checkout.required_field') },
        taxOffice: { required: t('common.checkout.required_field') },
        profession: { required: t('common.checkout.required_field') },
        companyAddress: { required: t('common.checkout.required_field') },
      }
    : undefined;
  const {
    bottlesReturn,
    setBottlesReturn,
    shouldDisplayBottlesReturn,
    bottlesReturnSubtitle,
    vouchers,
    setVouchers,
    vouchersSubtitle,
    shouldDisplayVouchers,
    returnSlip,
    setReturnSlip,
    shouldDisplayReturnSlip,
    bottlesReturnInfo,
  } = useCheckoutPreferences(config, wantsBottles, wantsVouchers);

  async function onSubmit() {
    const storage = window.localStorage;
    LoaderStore.setIsVisible(true);
    setRunCheck(false);
    jsonStorage.remove('temporaryInvoice', { storage });
    jsonStorage.remove('notSavedInvoiceFlag', { storage });

    if (
      !hasPredictiveTimeslot &&
      ((isPrebookingEnabled &&
        config?.timeslots?.calculation?.strategy !== 'USING_CART_INFO' &&
        !prebook?.reservation?.requestId) ||
        (!isPrebookingEnabled && genericIndexes?.selectedDayIndex === -1) ||
        (!isPrebookingEnabled && genericIndexes?.selectedIndex === -1) ||
        (isPrebookingEnabled &&
          config?.timeslots?.calculation?.strategy === 'USING_CART_INFO' &&
          genericIndexes?.selectedIndex === -1))
    ) {
      setSnackBarText(t('common.timeslots.checkout_select_timeslot_error'));
      setSnackBarOpen(true);
      LoaderStore.setIsVisible(false);
      return;
    }

    const isObjectFullyFilled = obj => {
      if (obj === undefined) return false;
      return Object.values(obj).every(value => value.trim() !== '');
    };

    if (!isObjectFullyFilled(invoiceToSend) && details) {
      setSnackBarText(t('common.invoice_error'));
      setSnackBarOpen(true);
      LoaderStore.setIsVisible(false);
      return;
    }
    submitOrderCart(
      addStickers(submitProducts()),
      !User.getValue() && !!GuestUserStore.getValue() ? Shop.getValue().selectedShop?._id : getShopId(),
      getDelivery(),
      User.getValue() && !GuestUserStore.getValue()
        ? User.getValue().addresses[selectedUserAddressIndex]
        : GuestUserStore.getValue().address,
      bags,
      formatTimeslots(genericTransformedTimeslots, genericIndexes),
      getCollectionTypes(),
      paymentOptions,
      prebook?.reservation?.requestId,
      getPaymentCard(),
      saveCard,
      bottlesReturnInfo,
      details ? invoiceToSend : undefined,
      getTimezone(),
      comments,
      hasPredictiveTimeslot,
      config?.order?.guest?.apiKey
    )
      .then(result => {
        if (
          result &&
          (result.status === ACCEPTED_STATE || result.status === 'PAYMENT_PENDING' || result.status === 'PENDING')
        ) {
          UserIsOfLegalAgeStore.clear();
          checkoutStore.update(result);
          Prebook.reset();
          isFromOrder.update(true);
          if (result?.paymentUrl && result?.paymentUrl?.length > 0) {
            checkoutStore.update(result);
            // router.push(result.paymentUrl);
            window.location.href = result.paymentUrl;
          } else {
            async function deleteCartOrder() {
              if (process.env.NEXT_PUBLIC_SYNC_CART === 'true' && !guestUser) {
                if (!isEditStarted?.getValue()) {
                  await deleteCart();
                }
              }
            }
            deleteCartOrder();
            clearCart();
            router.push('thank-you');
          }
        } else if (result?.error) {
          LoaderStore.setIsVisible(false);
          Prebook.reset();
          setSnackBarText(result.error?.response?.data?.userMessage ?? t('common.checkout_error'));
          setSnackBarOpen(true);
        }
      })
      .catch(error => {
        console.log(error);
        LoaderStore.setIsVisible(false);
        setSnackBarText(t('common.checkout_error'));
        setSnackBarOpen(true);
      });
  }

  const paymentDropdownOptions =
    getPaymentMethods(t('checkout.save_card'), selectedService) ?? mockCheckoutData.methods;
  useEffect(() => {
    const TimesSlotsSideSheetStore$ = TimesSlotsSideSheetStore.subscribe(setSideSheet);
    const PrebookSideSheetStore$ = PrebookSideSheetStore.subscribe(setSideSheet);
    const CouponAdditionSideSheetOpen$ = CouponAdditionSideSheetOpen.subscribe(setCouponSideSheet);
    const Prebook$ = Prebook.subscribe(setPrebook);
    setBags(getBagsConfigurations());
    const Shop$ = Shop.subscribe(setShop);
    async function getConfiguration() {
      const configuration = await getOrFetchConfiguration();
      setConfig(configuration);
    }
    getConfiguration();
    return () => {
      TimesSlotsSideSheetStore$.unsubscribe();
      PrebookSideSheetStore$.unsubscribe();
      CouponAdditionSideSheetOpen$.unsubscribe();
      Prebook$.unsubscribe();

      Shop$.unsubscribe();
    };
  }, []);

  useEffect(() => {
    PostalCode.lazyInit();
    const selectedShopId$ = SelectedShopId.subscribe(setSelectedShopId);

    const postalCode$ = PostalCode.subject.pipe(distinctUntilChanged()).subscribe(async value => {
      const _user = User.getValue();
      if (!selectedService || !selectedShop?._id || selectedShop?._id.length === 0) {
        return; // Wait until necessary state is ready
      }
      if (selectedService?.deliversToAddress) {
        if (value) {
          if (!config) return;
          let newEasyTimeslots = [];
          if (config?.timeslots?.calculation?.strategy === 'USING_CART_INFO') {
            newEasyTimeslots = await fetchTimeslotsDelivery(
              value,
              true,
              setGenericIndexes,
              selectedService?.id,
              selectedShop?._id,
              true,
              createTimeslotsProducts(order.products),
              requiresAddressLine
                ? constructAddressLine(User.getValue().addresses[selectedUserAddressIndex])
                : undefined
            );
          } else {
            newEasyTimeslots = await fetchTimeslotsDelivery(
              value,
              true,
              setGenericIndexes,
              selectedService?.id,
              selectedShop?._id,
              undefined,
              undefined,
              requiresAddressLine
                ? constructAddressLine(User.getValue().addresses[selectedUserAddressIndex])
                : undefined
            );
          }
          if (newEasyTimeslots.type === EXACT_DATE_TIMESLOT_TOKEN) {
            const localTimeslots = formatUTCTimeslotsToLocal(newEasyTimeslots.exactTimeTimeslots, timeFormat);

            setGenericTimeslots(localTimeslots);
            const newTransformedTimeslots = transfromTimeslots(localTimeslots, t);
            setGenericTransformedTimeslots(newTransformedTimeslots);
            setHasPredictiveTimeSlot(false);
            setPredictiveTimeslotText(['', '']);
          }

          if (newEasyTimeslots.type === PREDICTION_TIMESLOT_TOKEN) {
            setHasPredictiveTimeSlot(true);
            setPredictiveTimeslotText(
              createPredictiveTimeslotTextWithDate(
                newEasyTimeslots.prediction,
                t('checkout.estimated_delivery'),
                router.locale
              )
            );
          }
        }
      } else {
        if (selectedService) {
          if (!config) return;

          let takeAwayTimeslots;
          if (config?.timeslots?.calculation?.strategy === 'USING_CART_INFO') {
            takeAwayTimeslots = await fetchTimeslotsTakeAway(
              selectedService?.id,
              true,
              createTimeslotsProducts(order.products)
            );
          } else {
            takeAwayTimeslots = await fetchTimeslotsTakeAway(selectedService?.id);
          }
          if (takeAwayTimeslots) {
            const localTimeslots = formatUTCTimeslotsToLocal(takeAwayTimeslots.exactTimeTimeslots, timeFormat);
            setGenericTimeslots(localTimeslots);
            const newTransformedTimeslots = transfromTimeslots(localTimeslots, t);
            setGenericTransformedTimeslots(newTransformedTimeslots);
            changeSelectedIndexes(localTimeslots, setGenericIndexes, setMessage);
            setHasPredictiveTimeSlot(false);
            setPredictiveTimeslotText(['', '']);
          }
        }
      }
    });
    setBags(getBagsConfigurations());
    return () => {
      postalCode$.unsubscribe();
      selectedShopId$.unsubscribe();
    };
  }, [addressPickerStatus, postalCode, selectedShop?._id, selectedService, config, router.locale]);

  const { pointsTitle, pointsSubtitle, pointsSteps, setPointsSteps, canRedeem, showPoints } = usePoints(
    config,
    user?.totalLoyaltyPoints,
    pointsToRedeem,
    order
  );

  useEffect(() => {
    if (vouchers) {
      setPaymentOptions(prev => {
        const alreadyExists = prev.some(opt => opt.type === VOUCHER_TOKEN);
        if (alreadyExists) {
          return prev.map(opt => (opt.type === VOUCHER_TOKEN ? { ...opt, value: vouchers } : opt));
        } else {
          return [...prev, { type: VOUCHER_TOKEN, value: vouchers }];
        }
      });
    } else {
      setPaymentOptions(prev => [...prev.filter(val => val.type !== VOUCHER_TOKEN)]);
    }
  }, [vouchers, setPaymentOptions]);

  useEffect(() => {
    if (!hasCoupon || !coupon || coupon?.length === 0) {
      setPaymentOptions(prev => [...prev.filter(val => val.type !== 'COUPON')]);
    }
    if (couponError || couponSuccess) {
      setCouponError('');
      setCouponSuccess('');
      setCouponDiscount({ isValid: false, message: '', amount: 0 });
      setCouponIsEligible(true);
    }
  }, [coupon, hasCoupon]);

  useGenericTimeslots(
    true,
    sideSheet,
    addressPickerStatus,
    genericTimeslots,
    genericTransformedTimeslots,
    genericIndexes,
    setGenericIndexes,
    setMessage,

    setTimeslotDropdownOptions,
    () => {},
    selectedShopId,
    isPrebookingEnabled && config?.timeslots?.calculation?.strategy !== 'USING_CART_INFO',
    t
  );
  const onTimeslotsClick = () => {
    if (isPrebookingEnabled && config?.timeslots?.calculation?.strategy !== 'USING_CART_INFO') {
      PrebookSideSheetStore.open();
      return;
    }

    if (genericIndexes.selectedIndex === -1 && genericIndexes.selectedDayIndex === -1) return;

    TimesSlotsSideSheetStore.open();
  };

  const onCouponsClick = () => {
    CouponAdditionSideSheetOpen.open();
  };

  useCheckOrderCheckout(
    setOrder,
    bags,
    paymentOptions,
    getCollectionTypes,
    selectedUserAddressIndex,
    setCartPrice,
    prebook?.reservation?.requestId,
    genericIndexes,
    genericTransformedTimeslots,
    t('common.asides.side_cart.no_comment'),
    runCheck
  );

  useChargeDiscountBreakdown(
    order,
    bags,
    discountstate,
    hasCoupon,
    coupon,
    priceCart,
    setCartPrice,
    setBreakdownCategories,
    setPaymentOptions,
    amountToRedeem,
    pointsToRedeem,
    couponDiscount
  );

  const choosePaymentOption = i => {
    setPaymentIndex(i);
    addPaymentMethod(getProductsCartInfo(order.products || []), priceCart, paymentDropdownOptions[i]);

    PaymentOptionStore.update(paymentDropdownOptions[i]);
  };

  const handleCheckCoupon = async couponValue => {
    LoaderStore.setIsVisible(true);
    await checkCoupon(
      order.products,
      getShopId(),
      getDelivery(),
      User.getValue()?.addresses?.[selectedUserAddressIndex],
      getCollectionTypes,
      couponValue,
      setCouponError,
      setCouponDiscount,
      setCouponSuccess,
      bags,
      setPaymentOptions,
      paymentOptions,
      formatter,
      t,
      setCouponDiscountAmmount,
      setCouponIsEligible
    );
    LoaderStore.setIsVisible(false);
  };
  //this always returns one option cause we don't need more options in the drop down. Just display the selected value and open the sidesheet
  const getTimeSlotsPrebookOptions = () => {
    let msg = t('checkout.timeslot_default_selected');
    const hasSelectedTimeslot = prebook?.reservation;
    if (hasSelectedTimeslot) {
      msg = `${getCurrentDayTitle(
        prebook?.reservation?.startsAt,
        router.locale,
        t('common.days.today')
      )} ${formatPrebookDate(prebook.reservation?.endsAt)}, ${formatPrebookDate(
        prebook?.reservation.startsAt,
        timeFormat
      )} -  ${formatPrebookDate(prebook?.reservation.endsAt, timeFormat)}`;
    }

    return [{ name: msg, unavailable: false }];
  };

  function onChangeDayIndex(index) {
    setPreviousIndexes(genericIndexes);
    let newIndexes = { ...genericIndexes };
    newIndexes.selectedDayIndex = index;
    index === previousIndexes.selectedDayIndex
      ? (newIndexes.selectedIndex = previousIndexes.selectedIndex)
      : (newIndexes.selectedIndex = -1);

    setGenericIndexes(newIndexes);
  }

  function onChangeTimeslotIndex(index) {
    const transformedTimeslots = genericTransformedTimeslots[genericIndexes.selectedDayIndex];
    let newIndexes = { ...genericIndexes, selectedIndex: index };
    if (transformedTimeslots.timeslots[index].unavailable) return;
    FirstSelectedTimeslotStore.update(false);
    setGenericIndexes(newIndexes);
    GeneralSelectedTimeslotStore.update(newIndexes);
  }

  useEffect(() => {
    updateConfiguration();
  }, [router.locale]);

  const { data: totalActiveCoupons } = useQuery({
    queryKey: ['user', 'coupons', router.locale],
    queryFn: () => getCoupons(user.token),
    enabled: !!user?.token && config?.coupons?.wallet?.enabled === true,
    onError: console.log,
    select: response => {
      if (!response.data) return [];
      // daysUntilExpires(coupon.expiresAt);
      return response.data.filter(coupon => coupon.status === 'active').length;
    },
  });

  const couponStats = totalActiveCoupons;
  return (
    <div className={cn(styles.container)}>
      <div className={cn(styles.titles)}>
        <WaveBreadCrumb
          LinkComponent={Link}
          hasFirstArrow={false}
          items={breadCrumbItems}
          lastElementClickable={true}
          hasFirstIcon={true}
          FirstIcon={ArrowBack}
        />
        <div className={cn(styles.titleSubtitle)}>
          <Heading color={TextColorEnum.OnSurfaceHighEmphasis} type={HeadingEnum.HeadingL} bold={BoldEnum.Bold}>
            {t('checkout.title')}
          </Heading>
        </div>
      </div>
      <CheckoutPage
        guestContact={guestContactConfig}
        couponInputLabel={t('checkout.coupon_redeem')}
        headerTitle={t('checkout.title')}
        saveCard={saveCard}
        setSaveCard={setSaveCard}
        hasPredictiveTimeslot={hasPredictiveTimeslot}
        predictiveTimeslotText={predictiveTimeslotText}
        deliverToText={
          selectedService?.deliversToAddress ? t('checkout.deliver_to_text') : t('checkout.pickup_from_text')
        }
        additionalPaymentHold={
          order?.additionalPaymentHold?.value
            ? t('common.checkout.paymentHold_first') +
              ' ' +
              order?.additionalPaymentHold?.value * 100 +
              t('common.checkout.paymentHold_second')
            : undefined
        }
        DeliveryTypeTitle={
          selectedService?.title
            ? selectedService?.title
            : selectedService?.deliversToAddress
            ? t('checkout.delivery')
            : t('checkout.take_away')
        }
        headerPriceTitle={t('checkout.price_breakdown_title')}
        buttonLabel={t('checkout.complete_button')}
        categories={breakdownCategories ?? []}
        finalSumDescription={t('checkout.final_sum_description')}
        finalSumValue={priceCart}
        address={
          selectedService?.deliversToAddress
            ? GuestUserStore?.getValue() && !User.getValue()
              ? formatAddress(GuestUserStore.getValue().address, t, configVar?.format?.addressStreetPattern)
              : User?.getFormattedAddress(selectedUserAddressIndex, configVar?.format?.addressStreetPattern)
            : shop?.selectedShop?.name
        }
        buttonText={t('common.asides.save_btn')}
        textAreaTitle={t('checkout.text_area_title')}
        textAreaValue={comments}
        textAreaDescription={t('checkout.text_area_description')}
        dropdownTitle={t('checkout.payment_dropdown_title')}
        paymentDropdownOptions={paymentDropdownOptions ?? []}
        timeslotDropdownOptions={
          isPrebookingEnabled && config?.timeslots?.calculation?.strategy !== 'USING_CART_INFO'
            ? getTimeSlotsPrebookOptions()
            : timeslotDropdownOptions
        }
        agree={details}
        setAgree={() => setDetails(!details)}
        invoiceTitle={t('checkout.invoice_title')}
        onChangeDelivery={() => {
          SideSheetStore.open();
        }}
        onChangeComment={setComments}
        onPaymentChange={i => choosePaymentOption(i)}
        paymentIndex={paymentIndex}
        onOpenTimeslotsSideClick={onTimeslotsClick}
        onSubmit={onSubmit}
        couponRedeemTitle={t('checkout.coupon_redeem_title')}
        couponRedeemSubtitle={t('checkout.coupon_redeem_subtitle')}
        couponValue={coupon}
        setCouponValue={setCoupon}
        setCouponRedeemSelect={setHasCoupon}
        couponRedeemSelect={hasCoupon}
        checkCouponBtnLabel={t('checkout.check_coupon_btn_label')}
        shoppingBagsTitle={t('checkout.shopping_bags_title')}
        shoppingBagsSubtitle={
          bags
            ? `${order?.plasticBagsInfo.amount} ${t('checkout.shopping_bags')} - ${formatter.format(
                order?.plasticBagsInfo.price / 100
              )}`
            : t('checkout.shopping_bags_subtitle')
        }
        shoppingBags={bags}
        setShoppingBags={setBags}
        mandatoryShoppingBags={getBagsConfigurations()}
        onCouponCheckSubmit={handleCheckCoupon}
        invoiceValidationRules={invoiceValidationRules}
        couponRedeemError={couponError}
        couponRedeemSuccess={couponSuccess}
        showPoints={!guestUser && !!User.getValue() && showPoints}
        pointsTitle={pointsTitle}
        pointsSubtitle={pointsSubtitle}
        onChangeRedemption={PointsSideSheetStore.open}
        canRedeem={canRedeem}
        pointsSelected={pointsToRedeem > 0}
        onRedeem={PointsSideSheetStore.open}
        bottlesReturn={shouldDisplayBottlesReturn ? bottlesReturn : undefined}
        setBottlesReturn={shouldDisplayBottlesReturn ? setBottlesReturn : undefined}
        bottlesReturnSubtitle={bottlesReturnSubtitle}
        vouchers={shouldDisplayVouchers ? vouchers : undefined}
        setVouchers={shouldDisplayVouchers ? setVouchers : undefined}
        vouchersSubtitle={vouchersSubtitle}
        returnSlip={shouldDisplayReturnSlip ? returnSlip : undefined}
        setReturnSlip={shouldDisplayReturnSlip ? setReturnSlip : undefined}
        bottlesReturnTitle={t('checkout.bottles_return_title')}
        vouchersTitle={t('checkout.vouchers_title')}
        paymentMethodTitle={t('checkout.payment_details_title')}
        preferencesTitle={t('checkout.preferences_title')}
        deliveryOptionsTitle={t('checkout.delivery_options_title')}
        pointsChangeButtonText={t('checkout.points.change_btn')}
        pointsRedeemButtonText={t('checkout.points.redeem_btn')}
        invoiceLabels={{
          companyName: t('checkout.invoice.company_name'),
          profession: t('checkout.invoice.profession'),
          taxId: t('checkout.invoice.tax_id'),
          taxOffice: t('checkout.invoice.tax_office'),
          companyAddress: t('checkout.invoice.address'),
          companyPhone: t('checkout.invoice.telephone'),
        }}
        invoiceSwitchTitle={t('checkout.invoice.switchTitle')}
        // preferencesSwitchTitle={t('checkout.preferences.switchTitle')}
        // orderSwitchTitle={t('checkout.order.switchTitle')}
        // wantsBottles={wantsBottles}
        setWantsBottles={setWantsBottles}
        // wantsVouchers={wantsVouchers}
        setWantsVouchers={setWantsVouchers}
        invoiceSubtitle={t('checkout.invoice.subtitle')}
        commentMaxLength={config?.fields?.order?.commments?.maxLength ?? 1000}
        invoiceConfig={config?.fields?.invoice ?? null}
        minLengthErrorText={t('common.minimun_character')}
        patternField={t('common.invalid_input')}
        hasShoppingBags={configVar?.order?.bagsCalculation?.enabled}
        submitDisabled={!!guestUser ? !guestUser?.contactInfo?.email : undefined /* we need to add other cases here */}
        invoices={invoices}
        invoiceToSend={invoiceToSend}
        setInvoiceToSend={setInvoiceToSend}
        setSelectedCompanyIndex={setSelectedCompanyIndex}
        selectedCompanyIndex={selectedCompanyIndex}
        handleCreateInvoice={handleCreateInvoice}
        handleDeleteInvoice={handleDeleteInvoice}
        checkBoxChecked={checkBoxChecked}
        setCheckBoxChecked={setCheckBoxChecked}
        isFormVisible={isFormVisible}
        setIsFormVisible={setIsFormVisible}
        invoiceAction={invoiceAction}
        setInvoiceAction={setInvoiceAction}
        handleUpdateInvoice={handleUpdateInvoice}
        updateInvoiceIndex={updateInvoiceIndex}
        setUpdateInvoiceIndex={setUpdateInvoiceIndex}
        temporaryInvoice={temporaryInvoice}
        handleClearFormWarning={handleClearFormWarning}
        notSavedInvoiceFlag={notSavedInvoiceFlag}
        isGuest={isGuest}
        invoiceSelectorTexts={invoiceSelectorTexts}
        checkoutPageAriaLabels={{
          addBottleAriaLabel: t('checkout.add_bottle_aria_label'),
          removeBottleAriaLabel: t('checkout.remove_bottle_aria_label'),
          addVoucherAriaLabel: t('checkout.add_voucher_aria_label'),
          removeVoucherAriaLabel: t('checkout.remove_voucher_aria_label'),
        }}
        couponTitle={!couponStats || couponStats === 0 ? t('coupons.no_coupons') : t('coupons.have')}
        couponSecondTitle={!couponStats || couponStats === 0 ? '' : t('coupons.available_coupons')}
        couponSubTitle={t('coupons.choose')}
        couponsNumber={couponStats}
        couponIsEligible={couponIsEligible}
        coupon={coupon}
        couponDiscount={couponDiscountAmmount}
        couponWording={t('coupons.with_coupon')}
        couponInEligibleText={couponError || t('coupons.invalid_coupon')}
        handleCouponSectionClick={onCouponsClick}
      />
      {couponSideSheet && (
        <CouponsSidesheet
          user={user}
          selectedCoupon={coupon}
          setCoupon={setCoupon}
          handleCheckCoupon={handleCheckCoupon}
        />
      )}
      <PointsAside
        pointsSteps={pointsSteps}
        firstName={user?.firstName}
        lastName={user?.lastName}
        userPoints={user?.totalLoyaltyPoints}
        onSelectPoints={index => onSelectPoints(index, setPointsSteps)}
        onConfirmRedemption={() =>
          onConfirmRedemption(pointsSteps, setPointsToRedeem, setAmountToRedeem, setShowSnackBar, setPaymentOptions)
        }
        onClearRedemption={() => onClearRedemption(setPointsSteps)}
        onClose={() =>
          setPointsSteps(prev => prev.map(point => ({ ...point, selected: point.points === pointsToRedeem })))
        }
      />
      <OffersSnackbar
        emoji="🎉"
        text={t('checkout.discount_success')}
        hasCloseOption={false}
        position="center"
        type="success"
        bold={BoldEnum.Bold}
        className={styles.successMessage}
        hasShadow={true}
        autoWidth={true}
        open={showSnackBar}
        setOpen={setShowSnackBar}
      />
      <div style={{ width: '100%' }}>
        <SnackBar
          open={snackBarOpen}
          setOpen={() => setSnackBarOpen(false)}
          text={snackBarText}
          hasCloseOption={true}
          className={styles.snackBarContainer}
          position={'center'}
        />
      </div>
      {guestContactConfig?.enabled && guestContactAsideOpen ? (
        <SideSheet
          onClose={() => setGuestContactAsideOpen(false)}
          hasClose
          onSubmit={() => {
            GuestUserStore.update({ contactInfo: guestContactValues });
            setGuestContactAsideOpen(false);
          }}
          buttonText={t('checkout.guest_contact.submit')}
          header={t('checkout.guest_contact.header')}
          isDisabled={!guestContactValid}
        >
          <GuestContactForm
            onFormChange={(values, valid) => {
              setGeustContactValues(values);
              setGuestContactValid(valid);
            }}
            selectedCountryCode={countryCode}
            onCountryCodeClick={() => CountryCodeSideSheetStore.open()}
            overrideDefaultValues={
              guestUser?.contactInfo
                ? { email: guestUser?.contactInfo?.email, phone: guestUser?.contactInfo?.phone }
                : undefined
            }
            wordings={{
              countryCodeLabel: t('checkout.guest_contact.country_code'),
              emailLabel: t('checkout.guest_contact.email'),
              phoneLabel: t('checkout.guest_contact.phone'),
              shortDescription: t('checkout.guest_contact.short_description'),
            }}
            formFieldErrorMessages={formFieldErrorMessages}
          />
        </SideSheet>
      ) : null}
      {countryCodeAsideOpen ? <CountryCodeAside /> : false}
      {genericTransformedTimeslots && (
        <TimeslotsAside
          transformedTimeslots={genericTransformedTimeslots}
          genericIndexes={genericIndexes}
          onChangeDayIndex={index => onChangeDayIndex(index)}
          onChangeTimeslotIndex={index => {
            onChangeTimeslotIndex(index);
          }}
        />
      )}
    </div>
  );
}
